<template>
  <div class="QRcodeBig">
      <img :src="imgUrl" alt="" class="QRcodeImg">
  </div>
</template>

<script>

export default {
  data() {
    return{
      imgUrl: this.$route.params.imgUrl,
      assName: this.$route.params.assName
    }
  },
  created() {
      document.title = this.assName
  },
  mounted() {
    
  },
  methods: {

  }
}
</script>

<style scoped>
.QRcodeBig {
    width: 100vw;
    height: 100vh;
    background: #000;
}
.QRcodeImg {
    display: block;
    margin: 0 auto;
    padding-top: 25vh;
}
</style>
